import { FC } from 'react'

import type { Editor } from '@tiptap/react'
import { clsx } from 'clsx'

import { Dropdown } from '@tribeplatform/react-ui-kit/Dropdown'
import { SvgIcon } from '@tribeplatform/react-ui-kit/Icon'

import { MenuItemWrapper } from './BubbleMenuItemWrapper.js'

export const MenuMultiOptionItem: FC<{
  editor: Editor
  options: Array<{
    label: (editor: Editor) => string
    action: (editor: Editor) => void
    isActive: (editor: Editor) => boolean
  }>
  title?: string
  disabledTitle?: string
  disabled?: boolean
  className?: string
}> = props => {
  const { options, editor, title, disabledTitle, disabled, ...wrapperProps } =
    props
  const currentLabel =
    options.find(opt => opt.isActive(editor))?.label(editor) ?? ''

  const tooltip = disabled ? disabledTitle || title : title

  return (
    <MenuItemWrapper disabled={disabled} isActive={false} {...wrapperProps}>
      <Dropdown>
        <Dropdown.ButtonMinimal className="bg-transparent" title={tooltip}>
          <span className="inline-flex w-fit items-center">
            <SvgIcon className="w-4 h-4 relative top-px" name="chevron-down" />
            <span className="text-xs whitespace-nowrap">{currentLabel}</span>
          </span>
        </Dropdown.ButtonMinimal>
        <Dropdown.Items className="min-w-fit">
          {options.map(opt => {
            const label = opt.label(editor)
            const isSelected = opt.isActive(editor)
            return (
              <Dropdown.Item
                className={clsx(
                  'text-xs',
                  isSelected &&
                    'text-interactive hover:text-interactive-hovered',
                )}
                key={label}
                onClick={() => {
                  opt.action(editor)
                }}
              >
                {label}
              </Dropdown.Item>
            )
          })}
        </Dropdown.Items>
      </Dropdown>
    </MenuItemWrapper>
  )
}
